module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/sound-disabled.1c5083db.svg";